import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import WorkItemService from "../../../services/workitemService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListWorkItem from "../Components/ListWorkItem";
import MessageDialog from "../../../components/MessageDialog";
import ProjectCategoryService from "../../../services/ProjectCategoryService";

export default function ViewWorkItems() {

    const [workItems, setWorkItems] = useState([]);
    const [selected, setSelected] = useState(null);
    const [searchText, setSearchText] = useState("");
const [projectCategoryId, setProjectCategoryId] = useState("");
const [projectCategories, setProjectCategories] = useState([]);

    const [loading, setLoading] = useState(true);

    const [message, setMessage] = useState("");
    const [msgType, setMsgType] = useState("");

    // const messageTimer = useRef(null);

    const navigate = useNavigate();
    const location = useLocation();

    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;

    useEffect(() => {
        fetchData();
    }, [currentPage, searchText, projectCategoryId]);


    const fetchData = async () => {

        setLoading(true);

        try {
            const res = await WorkItemService.getAll(currentPage, itemsPerPage, searchText,projectCategoryId);

            setWorkItems(res.data || []);
            setPageCount(res.totalPages || 0);

        } catch (err) {

            showMessage("Error fetching data", "error");

        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchText, projectCategoryId]);

    useEffect(() => {
        if (location.state?.refresh) {
            fetchData();
            navigate(location.pathname, { replace: true });
        }
    }, [location]);

    useEffect(() => {
    fetchProjectCategories();
}, []);

const fetchProjectCategories = async () => {
    try {
        const res = await ProjectCategoryService.getAll();

        setProjectCategories(res.data || []);

    } catch (err) {
        console.error("Error fetching project categories:", err);
        showMessage("Error fetching project categories", "error");
    }
};

    const showMessage = (text, type = "error") => {
        setMessage(text);
        setMsgType(type);

        // if (messageTimer.current) clearTimeout(messageTimer.current);

        // messageTimer.current = setTimeout(() => {
        //     setMessage("");
        // }, 4000);
    };

    const handleSelect = (id) => {
        setSelected(id);
    };

    const handleAdd = () => {
        navigate("/cpnl/workitems/add");
    };

    const handleModify = () => {

        if (!selected) {
            showMessage("Select one record");
            return;
        }

        navigate(`/cpnl/workitems/add/${selected}`);
    };

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    const handleToggleStatus = async (item) => {

        const newStatus = item.status === "Active" ? "Inactive" : "Active";

        if (!window.confirm(`Change status to ${newStatus}?`)) return;

        try {

            await WorkItemService.updateStatus(item.id, newStatus);

            showMessage("Status updated", "success");

            fetchData();

        } catch (err) {

            showMessage("Error updating status");

        }
    };

    // const filtered = workItems.filter(item =>
    //     item.workItemCode?.toLowerCase().includes(searchText.toLowerCase())
    // );
    const filtered = workItems;

    return (
        <>
            <Breadcrumb pageTitle="Work Item" secondTitle="Masters" />

            <div className="row">
                <div className="card py-2 bg-white shadow-sm">

                    {/* {message && (
                        <div className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"}`}>
                            {message}
                        </div>
                    )} */}


                    <MessageDialog
                        message={message}
                        type={msgType}
                        setMessage={setMessage}
                        setMsgType={setMsgType}
                    />


                    <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
                         <div>
        <label className="form-label mb-1">
            Project Category
        </label>

        <select
            className="form-select"
            value={projectCategoryId}
            onChange={(e) => {
                setProjectCategoryId(e.target.value);
                setCurrentPage(1);
                setSelected(null);
            }}
        >
            <option value="">
                All Project Categories
            </option>
 {projectCategories.map((category) => (
                <option
                    key={category.id}
                    value={category.id}
                >
                    {category.categoryName}
                </option>
            ))}
        </select>
    </div>

                        <div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Work Item"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                        </div>


                        <div className="ms-auto d-flex gap-2">
                            <button
                                className="d-inline-flex btn btn-success"
                                onClick={handleAdd}
                                disabled={loading}
                            >
                                <i className="ti ti-plus me-1"></i> Add
                            </button>

                            <button
                                className="d-inline-flex btn btn-warning"
                                onClick={handleModify}
                                disabled={loading}
                            >
                                <i className="ti ti-pencil me-1"></i> Modify
                            </button>
                        </div>
                    </div>

                    <ListWorkItem
                        loading={loading}
                        filtered={filtered}
                        selected={selected}
                        handleSelect={handleSelect}
                        handleToggleStatus={handleToggleStatus}
                        pageCount={pageCount}
                        handlePageClick={handlePageClick}
                    />

                </div>
            </div>
        </>
    );
}